module.exports = __webpack_public_path__ + "static/media/banner-1.3e6c5a6b.png";